import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { fetchHeader } from "./HeaderQuery";
import "./Header.css";
import loaderHourglass from "../../assets/loader_hourglass.png";

const Header = ({ background }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isTop, setIsTop] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const loadHeader = async () => {
      try {
        const response = await fetchHeader();
        setData(response);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadHeader();
  }, []);

  // useEffect(() => {
  //   const handleScroll = () => setIsTop(window.scrollY < 15);
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

       // Always show header at top
      if (currentScrollY <= 0) {
        setIsTop(true);
        lastScrollY = currentScrollY;
        return;
      }

      if (currentScrollY < lastScrollY ) {
        // Scrolling up
        setIsTop(true);
      } else {
        // Scrolling down
        setIsTop(false);
      }

      lastScrollY = currentScrollY;
    };

    // handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  if (error) return <p>Error loading header</p>;
  //comment
  console.log("data:",data);
  const headerData = data?.header?.[0];
  if (!headerData || !headerData.enabled) return null;
  console.log("headerData:",headerData);

  const BASE_URL = process.env.REACT_APP_CMS_BASE_URL;
  const getUrl = (arr) => (arr && arr.length > 0 ? `${BASE_URL}${arr[0]}` : "");

  const locationItems =
    headerData.locationComponent?.contentItems?.filter((i) => i.enabled) || [];
  const infoItems =
    headerData.infoSectionComponent?.contentItems?.filter((i) => i.enabled) ||
    [];
  const links =
    headerData.linkComponent?.contentItems?.filter((i) => i.enabled) || [];

  return (
    <header className={`header ${isTop ? "at-top" : "scrolled"}`}>
      <div className="header-top">
        {locationItems.map((item, i) => (
          <div className="locationComponent" key={i}>
            {item.locationImage?.urls?.length > 0 && (
              <a
                href={item.locationUrl?.url}
                target="_blank"
                rel="noopener noreferrer"
                className="locationComponent-text"
              >
                <img
                  src={getUrl(item.locationImage.urls)}
                  alt="location"
                  className="locationComponent-image"
                />
              </a>
            )}

            <a
              href={item.locationUrl?.url}
              target="_blank"
              rel="noopener noreferrer"
              className="locationComponent-text"
            >
              {item.locationUrl?.text}
            </a>
          </div>
        ))}

        <div className="infoSectionComponent">
          {infoItems.map((info, i) => (
            <div className="infoSectionComponent-item" key={i}>
              {info.image?.urls?.length > 0 && (
                <img
                  src={getUrl(info.image.urls)}
                  alt="info"
                  className="infoSectionComponent-image"
                />
              )}
              <span className="infoSectionComponent-text">{info.text}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="navbarComponent">
        <div className="logoComponent">
          <NavLink to={headerData.logoUrl?.url || "/"}>
            <img
              src={getUrl(headerData.logoImage?.urls)}
              alt="logo"
              className="logoComponent-image"
            />
          </NavLink>
        </div>

        <nav className="linkComponent">
          {links.map((linkItem, i) => (
            <NavLink
              key={i}
              to={linkItem.url?.url || "#"}
              className={({ isActive }) =>
                isActive ? "linkComponent-active" : ""
              }
            >
              {linkItem.url?.text}
            </NavLink>
          ))}
        </nav>

        <div
          className="mobile-menu-btn"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          ☰
        </div>

        {mobileOpen && (
          <>
            <div
              className="mobile-overlay"
              onClick={() => setMobileOpen(false)}
            />

            <div className="mobile-sidebar">
              <div
                className="mobile-close"
                onClick={() => setMobileOpen(false)}
              >
                ✕
              </div>

              <nav className="mobile-links">
                {links.map((linkItem, i) => (
                  <NavLink
                    key={i}
                    to={linkItem.url?.url || "#"}
                    onClick={() => setMobileOpen(false)}
                  >
                    {linkItem.url?.text}
                  </NavLink>
                ))}
              </nav>

              <div className="mobile-info">
                {locationItems.map((item, i) => (
                  <div className="locationComponent" key={i}>
                    {item.locationImage?.urls?.length > 0 && (
                      <a
                        href={item.locationUrl?.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="locationComponent-text"
                      >
                        <img
                          src={getUrl(item.locationImage.urls)}
                          alt="location"
                          className="locationComponent-image"
                        />
                      </a>
                    )}

                    <a
                      href={item.locationUrl?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="locationComponent-text"
                    >
                      {item.locationUrl?.text}
                    </a>
                  </div>
                ))}

                <div className="infoSectionComponent">
                  {infoItems.map((info, i) => (
                    <div className="infoSectionComponent-item" key={i}>
                      {info.image?.urls?.length > 0 && (
                        <img
                          src={getUrl(info.image.urls)}
                          alt="info"
                          className="infoSectionComponent-image"
                        />
                      )}
                      <span className="infoSectionComponent-text">
                        {info.text}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
